import './datadog-tracking';
import '../sass/tracking.scss';

import renderTrackingPage from './renderTrackingPage';

renderTrackingPage(process.env.APP_MOUNT_ID);
